export const BACKEND_UNAVAILABLE_MESSAGE = "Server Plzeň Jede je momentálně nedostupný. Jde o problém na straně serveru, nikoliv o chybu této stránky. Na vyřešení problému se pracuje. Zkuste to prosím znovu později.";
export const CLIENT_OFFLINE_MESSAGE = "Vaše zařízení není připojeno k internetu. Zkontrolujte prosím své připojení a zkuste to znovu.";

export class ApiConnectionError extends Error {
  constructor(public readonly offline: boolean, public readonly statusCode: number = 0) {
    super(offline ? CLIENT_OFFLINE_MESSAGE : BACKEND_UNAVAILABLE_MESSAGE);
    this.name = "ApiConnectionError";
  }
}

export const apiAvailability = new EventTarget();
export let apiConnectionError: ApiConnectionError | null = null;
let failureRevision = 0;

function reportConnectionError(statusCode: number = 0): ApiConnectionError {
  const error = new ApiConnectionError(navigator.onLine === false, statusCode);
  failureRevision++;
  apiConnectionError = error;
  apiAvailability.dispatchEvent(new Event("change"));
  return error;
}

export async function fetchApi(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const revision = failureRevision;
  let response: Response;
  try {
    response = await fetch(input, init);
  } catch (error) {
    if (init?.signal?.aborted || (error instanceof Error && error.name === "AbortError")) throw error;
    throw reportConnectionError();
  }

  const code = !response.ok ? await readApiErrorCode(response) : undefined;
  if (code === "BackendUnavailable" || ([502, 503, 504, 523].includes(response.status) && code !== "TransitDataUnavailable")) throw reportConnectionError(response.status);

  if (revision === failureRevision && apiConnectionError) {
    apiConnectionError = null;
    apiAvailability.dispatchEvent(new Event("change"));
  }
  return response;
}

async function readApiErrorCode(response: Response): Promise<string | undefined> {
  const contentType = response.headers.get("content-type");
  if (!contentType?.includes("application/json") && !contentType?.includes("application/problem+json")) return undefined;

  try {
    const error: unknown = await response.clone().json();
    return error && typeof error === "object" && "code" in error && typeof error.code === "string" ? error.code : undefined;
  } catch {
    return undefined;
  }
}
